import { render, staticRenderFns } from "./SingleForm.vue?vue&type=template&id=133e6ed1&"
import script from "./SingleForm.vue?vue&type=script&lang=js&"
export * from "./SingleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports